"use client";

import { ExperienceConfiguration } from "@ninetailed/experience.js-next";
import NinetailedGoogleTagmanagerPlugin from "@ninetailed/experience.js-plugin-google-tagmanager";
import NinetailedInsightsPlugin from "@ninetailed/experience.js-plugin-insights";
import { NinetailedProvider } from "@ninetailed/experience.js-react";
import { useMemo } from "react";

type Audience = {
  id: string;
  name: string;
  description?: string | undefined;
};

export default function Providers({
  children,
}: {
  ninetailed?: {
    preview: {
      allExperiences: ExperienceConfiguration[];
      allAudiences: Audience[];
    };
  };
  children: React.ReactNode;
}) {
  // Preview plugin (sidebar) intentionally not registered so the Ninetailed preview panel never shows.
  // Plugins are created once so NinetailedProvider does not re-initialise on every render
  const plugins = useMemo(() => [new NinetailedInsightsPlugin(), new NinetailedGoogleTagmanagerPlugin()], []);

  return (
    <NinetailedProvider
      clientId={process.env.NEXT_PUBLIC_NINETAILED_CLIENT_ID || ""}
      environment={process.env.NEXT_PUBLIC_NINETAILED_ENVIRONMENT || ""}
      plugins={plugins}
    >
      {children}
    </NinetailedProvider>
  );
}
